import react, { useEffect, useRef, useState } from "react";
import "../styles/PatientReportFileTemplateCreate.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  postAppointment,
} from "../Redux/Thunk/Actions";
import { prescriptionType, patientid } from "../Redux/Slice/rootSlice";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import codoid from "../assets/images/logo.png";
import headerimage from "../assets/images/ascas.svg";
import Headers from "./Header/Headers";
import { PrescriptionFooter } from "./Prescription Footer/PrescriptionFooter";

function RplTemplate(props) {
  const selectedTab = useSelector((state) => state.counter.prescriptionType);
  const patientId = useSelector((state) => state.counter.patientid);
  const [show, setshow] = useState(false);
  const [NumToWords, setNumToWords] = useState(0);
  const Content = useRef();
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
    });
  const [valueChange, setvalueChange] = useState({
    gender1: "Male",
    gender2: "Male",
    bloodGroup1: "A+",
    bloodGroup2: "A+",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
    if (e.target.name === "nextappointment") {
      const dateTime = e.target.value.split("T");
      setAppointmentData({
      ...appointmentData,
      date: dateTime[0],
      time: dateTime[1],
      p_uhid: props.patientsData.p_uhid,
      name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
      status: "Not Visited",
      notes: "Booking Visit",
      patient_id: patientId,
      });
      }
  };
  const handletest = () => {
    props.loaderchange("true")
    setshow(true);
    setTimeout(() => {
      const CreateThunk = async () => {
        let htmlPayload;
        htmlPayload = document.getElementById(
          "prescriptionReportWrap"
        ).innerHTML;
        // console.log(htmlPayload, "liki");
        const payload = {
          payload: {
            patient_id: patientId,
            template_type: selectedTab,
            prescription_template: htmlPayload,
          },
        };

        const createNewAppointment = async () => {
          console.log(appointmentData);
          await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment();
        props.loaderchange(true);
        const patentReport = postPrescriptionTemplate(payload);
        const response = await dispatch(patentReport);
        if (response?.payload?.status?.code === 200) {
          props.loaderchange(false);
          navigate("/PatientView");
          Swal.fire({
            title: "Successful.",
            text: "Report added successful.",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
    props.loaderchange("false")

        } else {
          props.loaderchange("false");
          props.popupalert("true");
          props.popuptext("Network went wrong, Please try after some time.");
          // props.popuptext(response?.status?.message);
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
        }
      };
      CreateThunk();
    }, 2000);
    props.loaderchange("false")

  };
  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };
  return (
    <>
      <div
        style={{ backgroundColor: "white"
          
         }}
        className="patientreport"
        id="reportcreate"
      >
        {/* Billing Heading */}

        <>
          <div
            style={{
              display: "flex",
              // gridTemplateColumns: "1fr",
              alignItems: "center",
              justifyContent: "center",
              //   gap: "16px",
              // overflowX: "hidden",
              maxWidth: "97%",
              margin: "0 auto",
              // border: "1px solid",
            }}
            className="report-template-wrap1"
          >
            <div style={{ width: "100%" }}>
              <img
                className="header_image"
                // src={"https://s3.amazonaws.com/likodi.com/ascslogo.png"}
                src={headerimage}
                style={{
                  // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                  width: "100%",
                  margin: "0 auto",
                }}
              ></img>
            </div>
          </div>
        </>

        <div
          style={{
            maxWidth: "97%",
            margin: "0 auto",
            // border: "1px solid",
            // borderTop: "none",
            paddingTop: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={valueChange.gender1}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
          <table
            style={{
              borderSpacing: "0",
              marginBottom: "30px",
              width: "98%",
            }}
          >
            <thead style={{ border: "1px solid", padding: "0px" }}>
              <tr
                style={{
                  border: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <th style={{ border: "1px solid", padding: "10px" }}>
                  Factors
                </th>
                <th style={{ border: "1px solid", padding: "10px" }}>DATE</th>
                <th style={{ border: "1px solid", padding: "10px" }}>
                  Results
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  UTERINE FACTORS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;3D USG
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="usgDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.usgDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="usgRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.usgRemark}
                  </span>
                </td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;MRI pelvis
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="mriDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.mriDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="mriRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.mriRemark}
                  </span>
                </td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;HSG
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="hsgDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.hsgDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="hsgRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.hsgRemark}
                  </span>
                </td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Hysteroscopy
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="HysteroscopyDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.HysteroscopyDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="HysteroscopyRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.HysteroscopyRemark}
                  </span>
                </td>
              </tr>
              {/* EMPTY */}
              {/* <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr> */}
              {/* AUTOIMMUNE DISORDERS */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  AUTOIMMUNE DISORDERS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/* APLA-ACA, B2GP, LAC */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;APLA-ACA, B2GP, LAC
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="aplaDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.aplaDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="aplaRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.aplaRemark}
                  </span>
                </td>
              </tr>
              {/* ANA */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;ANA
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="anaDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.anaDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="anaRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.anaRemark}
                  </span>
                </td>
              </tr>
              {/* Protein C/ Protein */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Protein C/ Protein
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="proteinDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.proteinDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="proteinRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.proteinRemark}
                  </span>
                </td>
              </tr>
              {/* Antithrambin 111, Factor V leiden */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Antithrambin 111, Factor V leiden
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="AntithrambinDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.AntithrambinDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="AntithrambinRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.AntithrambinRemark}
                  </span>
                </td>
              </tr>
              {/* MTFR Mutation */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;MTFR Mutation
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="mtfrDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.mtfrDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="mtfrRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.mtfrRemark}
                  </span>
                </td>
              </tr>
              {/* APTT / GTT */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;APTT / GTT
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="apttDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.apttDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="apttRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.apttRemark}
                  </span>
                </td>
              </tr>
              {/* EMPTY */}
              {/* <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr> */}
              {/* ENDOCRINE FACTORS */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  ENDOCRINE FACTORS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/*TSH*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;TSH
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="tshDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.tshDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="tshRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.tshRemark}
                  </span>
                </td>
              </tr>
              {/*Anti TG, Anti TPO Antibodies*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Anti TG, Anti TPO Antibodies
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="tgDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.tgDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="tgRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.tgRemark}
                  </span>
                </td>
              </tr>
              {/*Anti TG, Anti TPO Antibodies*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Prolactin
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="prolactinDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.prolactinDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="prolactinRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.prolactinRemark}
                  </span>
                </td>
              </tr>
              {/*FBS / GTT*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;FBS / GTT
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="fbsDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.fbsDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="fbsRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.fbsRemark}
                  </span>
                </td>
              </tr>
              {/*HBA1C*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;HBA1C
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="HBA1CDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.HBA1CDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="HBA1CRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.HBA1CRemark}
                  </span>
                </td>
              </tr>
              {/*EMPTY*/}
              {/* <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr> */}
              {/*GENETIC TEST - Couple*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;GENETIC TEST - Couple
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="geneticTestDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.geneticTestDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="geneticTestRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.geneticTestRemark}
                  </span>
                </td>
              </tr>
              {/*Karyotyping of POC*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Karyotyping of POC
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="karyotypingDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.karyotypingDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="karyotypingRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.karyotypingRemark}
                  </span>
                </td>
              </tr>
              {/*Karyotyping of POC*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Fetal autopsy
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="fetalAutopsyDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.fetalAutopsyDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="fetalAutopsyRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.fetalAutopsyRemark}
                  </span>
                </td>
              </tr>
              {/*Karyotyping (Wife)*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Karyotyping (Wife)
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="KaryotypingWDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.KaryotypingWDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="KaryotypingWRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.KaryotypingWRemark}
                  </span>
                </td>
              </tr>
              {/*Karyotyping (Husband)*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Karyotyping (Husband)
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="KaryotypingMDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.KaryotypingMDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="KaryotypingMRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.KaryotypingMRemark}
                  </span>
                </td>
              </tr>
              {/*EMPTY*/}
              {/* <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr> */}
              {/*INFECTION*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;INFECTION
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/*Endometrial biopsy CD - 138 / TB - PCR*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Endometrial biopsy CD - 138 / TB - PCR
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="endometrialDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.endometrialDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="endometrialRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.endometrialRemark}
                  </span>
                </td>
              </tr>
              {/*Syphillis RPR /VORL*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Syphillis RPR /VORL
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="syphillisDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.syphillisDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="syphillisRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.syphillisRemark}
                  </span>
                </td>
              </tr>
              {/*IGM Chlamydia, Ureaplasma Mycoplasma*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;IGM Chlamydia, Ureaplasma Mycoplasma
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="igmDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.igmDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="igmRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.igmRemark}
                  </span>
                </td>
              </tr>
              {/*Parvovirus B19*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Parvovirus B19
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="parvovirusDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.parvovirusDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="parvovirusRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.parvovirusRemark}
                  </span>
                </td>
              </tr>
              {/*Empty*/}
              {/* <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr> */}
              {/*MALE FACTORS*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  MALE FACTORS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/*tsh-m*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;TSH
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="tshMDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.tshMDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="tshMRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.tshMRemark}
                  </span>
                </td>
              </tr>
              {/*HbA1C / GTT*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;HbA1C / GTT
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="hbalcMDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.hbalcMDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="hbalcMRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.hbalcMRemark}
                  </span>
                </td>
              </tr>
              {/*sperm dfl*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Sperm DFL
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="spermDflDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.spermDflDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="spermDflRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.spermDflRemark}
                  </span>
                </td>
              </tr>
              {/*Smoking / Drug abuse / Alcohol / Caffeine*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Smoking / Drug abuse / Alcohol / Caffeine
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="smokingDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.smokingDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="smokingRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.smokingRemark}
                  </span>
                </td>
              </tr>
              {/*Empty*/}
              {/* <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>
      {/* Details-2 */}

      {/* Footer */}
      <p style={{fontWeight:"600"}}>
NEXT APPOINTMENT -{" "}
<input
name="nextappointment"
onChange={handleChange}
type="datetime-local"
// type="date"
/>
</p>
      <div className="Footer">
        <button onClick={handletest} className="Button_Create">
          Add Report
        </button>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div>
            <table style={{width:'100%'}}>
              <thead>
                <tr>
                  {renderTableTH("Factors")}
                  {renderTableTH("Date")}
                  {renderTableTH("Results")}
                </tr>
              </thead>
              <tbody>
                <tr>{renderTableTH("UTERINE FACTORS", { colspans: 3 })}</tr>
                {[
                  " • 3D USG",
                  " • MRI pelvis",
                  " • HSG",
                  " • Hysteroscopy",
                ].map((ele, ind) => {
                  let value = [
                    "usgDate||usgRemark",
                    "mriDate||mriRemark",
                    "hsgDate||hsgRemark",
                    "HysteroscopyDate||HysteroscopyRemark",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]?.split("-").reverse().join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>
                  {renderTableTH("AUTOIMMUNE DISORDERS", { colspans: 3 })}
                </tr>
                {[
                  " • APLA-ACA, B2GP, LAC",
                  " • ANA",
                  " • Protein C/ Protein",
                  " • Antithrambin 111, Factor V leiden",
                  " • MTFR Mutation",
                  " • APTT / GTT",
                ].map((ele, ind) => {
                  let value = [
                    "aplaDate||aplaRemark",
                    "anaDate||anaRemark",
                    "proteinDate||proteinRemark",
                    "AntithrambinDate||AntithrambinRemark",
                    "mtfrDate||mtfrRemark",
                    "apttDate||apttRemark",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]?.split("-").reverse().join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>{renderTableTH("ENDOCRINE FACTORS", { colspans: 3 })}</tr>
                {[
                  " • TSH",
                  " • Anti TG, Anti TPO Antibodies",
                  " • Prolactin",
                  " • FBS / GTT",
                  " • HBA1C",
                  " • GENETIC TEST - Couple",
                  " • Karyotyping of POC",
                  " • Fetal autopsy",
                  " • Karyotyping (Wife)",
                  " • Karyotyping (Husband)",
                ].map((ele, ind) => {
                  let value = [
                    "tshDate||tshRemark",
                    "tgDate||tgRemark",
                    "prolactinDate||prolactinRemark",
                    "fbsDate||fbsRemark",
                    "HBA1CDate||HBA1CRemark",
                    "geneticTestDate||geneticTestRemark",
                    "karyotypingDate||karyotypingRemark",
                    "fetalAutopsyDate||fetalAutopsyRemark",
                    "KaryotypingWDate||KaryotypingWRemark",
                    "KaryotypingMDate||KaryotypingMRemark",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]?.split("-").reverse().join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>{renderTableTH("INFECTION", { colspans: 3 })}</tr>
                {[
                  " • Endometrial biopsy CD - 138 / TB - PCR",
                  " • Syphillis RPR /VORL",
                  " • IGM Chlamydia, Ureaplasma Mycoplasma",
                  " • Parvovirus B19",
                ].map((ele, ind) => {
                  let value = [
                    "endometrialDate||endometrialRemark",
                    "syphillisDate||syphillisRemark",
                    "igmDate||igmRemark",
                    "parvovirusDate||parvovirusRemark",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]?.split("-").reverse().join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>{renderTableTH("MALE FACTORS", { colspans: 3 })}</tr>
                {[
                  " • TSH",
                  " • HbA1C / GTT",
                  " • Sperm DFL",
                  " • Smoking / Drug abuse / Alcohol / Caffeine",
                ].map((ele, ind) => {
                  let value = [
                    "tshMDate||tshMRemark",
                    "hbalcMDate||hbalcMRemark",
                    "spermDflDate||spermDflRemark",
                    "smokingDate||smokingRemark",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]?.split("-").reverse().join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

<div style={{ marginTop: "10px" }}>
{renderReportfield("Next Appointment : ",appointmentData.date?.split("-").reverse().join("-"))}
</div>
<p class="Dani"></p>
<PrescriptionFooter/>
        </div>
      </div>
    </>
  );
}

export default RplTemplate;
